import { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { setUserDatalayerSent } from "lib/redux/actions"
import { sendDataLayer } from "lib/function"
import Cookies from "js-cookie"

export const useUserDatalayer = () => {
  const dispatch = useDispatch()
  const { user_data, user_datalayer_sent } = useSelector((state) => state.auth)
  useEffect(() => {
    // Check if user is logged in and we haven't sent the datalayer for this user
    const accessToken = Cookies.get(`${process.env.ACCESS_TOKEN}`)

    if (
      accessToken &&
      user_data &&
      user_data.id &&
      user_datalayer_sent !== user_data.id
    ) {
      // Send the datalayer events
      sendDataLayer({
        user_id: user_data.id,
      })
      sendDataLayer({
        customer_unique_id: user_data.id,
      })

      sendDataLayer({
        event: "login",
        method: "Email",
      })
      // Mark this user as having datalayer sent
      dispatch(setUserDatalayerSent(user_data.id))
    } else if (user_datalayer_sent === "LOGOUT" && !accessToken) {
      setTimeout(() => {
        sendDataLayer({
          customer_unique_id: 0,
        })
        // Mark this user as having datalayer sent 0
        dispatch(setUserDatalayerSent(0))
      }, 3000) // Delay to ensure logout is processed
    }
  }, [user_data, user_datalayer_sent, dispatch])
}
